import moment from "moment";

export const show_proper_words = (text) => {
  let replace_string = "";
  if (text) {
    replace_string = String(text).replace(/[-_]/g, " ");
    replace_string = replace_string
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }
  return replace_string;
};

export const convertCurrencyToSign = (currency) => {
  let currency_lowercase = currency?.toLowerCase();
  if (currency_lowercase === "gbp" || currency_lowercase === "GBP") {
    return "£";
  } else if (currency_lowercase === "eur" || currency_lowercase === "EUR") {
    return "€";
  } else if (currency_lowercase === "usd" || currency_lowercase === "USD") {
    return "$";
  } else {
    return "";
  }
};

export function validateEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export const dd_date_format = (date) => {
  return moment(date).format("DD-MM-YYYY");
};
export const usStates = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
];

export const formatExpertise = (arr) => {
  if (!Array.isArray(arr)) return "";

  return arr
    .map((item) =>
      String(item)
        .split("_")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(" ")
    )
    .join(", ");
};
export const handledateFormate = (date) => {
  if (!date) return "";
  const dateObj = new Date(date);
  return moment(dateObj).format("DD-MM-YYYY");
};

export const handleExportCsv = (filename, data) => {
  const csvData = data.map((row) => {
    return Object.values(row)
      .map((value) => `"${value}"`)
      .join(",");
  });
  const csvContent = `data:text/csv;charset=utf-8,${csvData.join("\n")}`;
  const encodedUri = encodeURI(csvContent);
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
};

export const handleImageDownload = (url, data) => {
  const link = document.createElement("a");
  link.href = url;
  link.download = data.filename || "image.png";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
